import { useEffect, useRef, useState } from 'react';
import DownloadIcon from '../svgs/Download';
import Style from './style.module.css'
import Cruz from '../svgs/Cruz';

const InputRHF = ({
    link = null,
    argentino,
    type = "text",
    label,
    login = null,
    register = null,
    errors,
    resetField,
    campo,
    opciones,
    placeholder,
    setValue,
    watch,
    cols = 3,
    rows = 3,
    className,
    setImg,
    img,
    classRadio = 'd-flex gap-3 align-items-center',
}) => {
    // const [imageSrc, setImageSrc] = useState(null);

    const fileInputRef = useRef(null);


    const handleDivClick = () => {
        if (fileInputRef.current)
            fileInputRef.current.click();
    };

    // Función para manejar el cambio de archivo
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setValue(campo, event.target.files)

        // Verificamos si hay un archivo seleccionado
        if (file) {
            const reader = new FileReader();

            // Cuando se termine de leer el archivo, actualizamos el estado con la URL de la imagen
            reader.onloadend = () => {
                // setImageSrc(reader.result);
                setImg(reader.result); // Guardamos la URL de la imagen en el estado
            };

            // Leemos el archivo como URL
            reader.readAsDataURL(file);
        }
    };

    const [errorInput, setErrorInput] = useState()

    useEffect(() => {
        if (campo in errors) {
            // console.log('entre')
            // console.log(campo)
            setErrorInput(true)
        }
    }, [])

    // console.log(argentino)


    return (
        <div className={`${className} `}>

            {label && <label className={`${login ? Style.login : type != 'checkbox' ? Style.label : Style.labelCheck}`} style={{ fontSize: type == 'checkbox' && "13px" }} htmlFor={campo} >{label}</label>}
            {link && <a style={{ fontSize: "13px", color:"#873DD1" }} className='ms-2' href={link} target='__blank'>{link}</a>}
            {/* {link && <a style={{ fontSize: "13px" }} className='text-info ms-2' href={link} target='__blank'>{link}</a>} */}

            {/* <div className={`${Style.containerInput}`}> */}
            {

                type == "checkbox"
                    ?
                    // <div className={`${errors[campo] ? Style.containerSelectError : Style.containerSelect} ${errors[campo] && Style.effInputError}`}>
                    <input type="checkbox" style={{ width: "20px", height: "20px", verticalAlign: "middle" }} className='ms-2 '
                        {...(register && { ...register(campo) })}
                    />
                    // </div>
                    :
                    type == "select"
                        ?
                        <div className={`${errors[campo] ? Style.containerSelectError : Style.containerSelect} ${errors[campo] && Style.effInputError}`}>
                            <select
                                // className={`  ${errors[campo] && "is-invalid"} ${errors[campo] && Style.effInputError && Style.errors}`} placeholder={placeholder} type={type} onChange={(e) => setValue(campo, e.target.value)}
                                className={`form-select ${Style.input} ${errors[campo] && "is-invalid"}`} value={watch && watch(campo)} name={campo}
                                {...(register && { ...register(campo) })}
                            >
                                {placeholder && <option value={""}>{placeholder}</option>}
                                {
                                    opciones?.map((opc, index) => {
                                        return (
                                            <option key={index} value={opc.value}>{opc.name}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        : type == "textarea"
                            ?
                            <textarea className={`form-control ${Style.input} ${errors[campo] && "is-invalid"}`} name={campo} placeholder={placeholder} cols={cols} rows={rows} onChange={(e) => setValue(campo, e.target.value)}
                                {...(register && { ...register(campo) })}
                            />
                            : type == "radio"
                                ?
                                <div className={classRadio} style={{ minHeight: "35px" }}>
                                    {opciones?.map((opc, index) => {
                                        return (
                                            <label className='d-flex gap-1' htmlFor={opc.id} key={opc.id}>
                                                <input type="radio" value={opc.value} id={opc.id} onChange={(e) => setValue(campo, e.target.value)}
                                                    {...(register && { ...register(campo) })}
                                                />
                                                {opc.name}
                                            </label>
                                        )
                                    })}
                                </div>
                                : type == "file"
                                    ?

                                    <div className=' w-100  rounded border-4 border-secondary d-flex justify-content-center align-items-center overflow-hidden' style={{ borderStyle: "dotted", height: "103px" }}
                                        onClick={handleDivClick}
                                    >

                                        {img ? (

                                            <div className="image-preview h-100 w-100 position-relative">
                                                <div className='position-absolute bg-danger' style={{ right: "5px", top: "5px" }}
                                                    onClick={() => {
                                                        setValue(campo, null)
                                                        setImg(null)
                                                    }
                                                    }
                                                >
                                                    <Cruz height={'20px'} color={'#FFF'} />
                                                </div>

                                                <img src={img} alt="Vista previa" style={{ objectFit: "contain", width: "100%", height: "100%", display: "block" }} />

                                            </div>
                                        )
                                            :
                                            <>
                                                <div className='d-flex flex-column align-items-center'>
                                                    <DownloadIcon color="#8B9298" width="35px" height="35px" />
                                                    <p className='font-bold text-secondary'>Subir archivo</p>
                                                </div>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={handleFileChange}
                                                    accept="image/*"
                                                // {...(register && { ...register(campo) })}
                                                />
                                            </>
                                        }

                                    </div>
                                    :

                                    type == "number"
                                        ?
                                        <input
                                            // data-fase={fase}
                                            onKeyDown={(e) => {
                                                // Evita las teclas no deseadas
                                                if (
                                                    ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "."].includes(e.key) // Permite un solo punto decimal
                                                ) {
                                                    e.preventDefault();
                                                }


                                            }}
                                            onWheel={(e) => {
                                                e.currentTarget.blur()
                                            }}
                                            autoComplete='off'
                                            onInput={(e) => {
                                                const value = e.target.value;
                                                if (value.length > 4 && campo == 'numero_tramite') {
                                                    e.target.value = value.slice(0, 4); // Limita a 4 caracteres
                                                }
                                                if (value.length > 15 && campo == 'telefono') {
                                                    e.target.value = value.slice(0, 15); // Limita a 15 caracteres
                                                }

                                                if (campo == 'dni') {

                                                    if (argentino == '1' && value.length > 8) {

                                                        e.target.value = value.slice(0, 8); // Limita a 15 caracteres
                                                    }
                                                }

                                                // if (value.length > 8 && campo == 'dni' && argentino == '1') {
                                                //     e.target.value = value.slice(0, 8); // Limita a 15 caracteres
                                                // }
                                            }} name={campo}
                                            // style={{ width: widthInput && widthInput }} 
                                            className={`  ${errors[campo] && "is-invalid"} ${errors[campo] && Style.errors}`} placeholder={placeholder} type={type} onChange={(e) => setValue(campo, e.target.value)}
                                            {...(register && { ...register(campo) })}
                                        />
                                        :
                                        <input
                                            autoComplete='off'
                                            onKeyDown={(e) => {
                                                if (campo == 'email_confirmation')
                                                    if ((e.ctrlKey || e.metaKey) && e.key == 'v') {
                                                        e.preventDefault()
                                                    }
                                            }}
                                            name={campo} className={`  ${errors[campo] && "is-invalid"}  ${Style.input} ${errorInput && "errors"} ${errors[campo] && Style.errors}`} placeholder={placeholder} type={type} onChange={(e) => setValue(campo, e.target.value)}
                                            {...(register && { ...register(campo) })}
                                        />
            }

            {
                type != "file" &&
                <>
                    {
                        errors[campo] && type != 'checkbox'
                            ? <p className={Style.error} >{errors[campo].message}</p>
                            : errors[campo] && type == 'checkbox'
                                ? <p
                                    className={Style.error}
                                // style={{marginTop: "0.1rem", fontSize: "12px", paddingLeft: "20px", color: "#FF40DB"}} 
                                >{errors[campo].message}</p>
                                :
                                type == 'checkbox' ?
                                    <div className={Style.error} />
                                    :
                                    <div className={Style.error} />
                    }
                </>
            }

        </div >
    );
}
export default InputRHF;